import { useT } from '../../lib/i18n.tsx'
import { cn } from '../../kit/util.ts'

/** The app mark: three linked nodes on amber. */
export function BrandMark({ size = 'md', className }: { size?: 'md' | 'lg'; className?: string }) {
  const lg = size === 'lg'
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center bg-accent text-accent-ink shadow-glow',
        lg ? 'size-12 rounded-xl' : 'size-7 rounded-md',
        className,
      )}
    >
      <svg viewBox="0 0 24 24" width={lg ? 30 : 18} height={lg ? 30 : 18} fill="none" aria-hidden>
        <path d="M7 8.5 16.5 6.5M7 8.5l4.5 9M16.5 6.5l-5 11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" opacity="0.55" />
        <circle cx="7" cy="8.5" r="2.6" fill="currentColor" />
        <circle cx="16.5" cy="6.5" r="2.1" fill="currentColor" />
        <circle cx="11.5" cy="17.5" r="2.9" fill="currentColor" />
      </svg>
    </span>
  )
}

export function BrandName({ className }: { className?: string }) {
  const t = useT()
  return (
    <span className={cn('flex min-w-0 flex-col leading-none', className)}>
      <span className="font-display text-base font-semibold tracking-tight text-ink">{t('common.appName')}</span>
      <span className="mt-1 font-mono text-xs text-ink-faint">{t('common.appTagline')}</span>
    </span>
  )
}
